// A row that scrolls sideways when it does not fit, and shows it: the edge with more beyond it fades out.
import { useEffect, useRef, type HTMLAttributes } from 'react';

export function Strip({ className = '', children, ...rest }: HTMLAttributes<HTMLDivElement>) {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const mark = () => {
      el.toggleAttribute('data-l', el.scrollLeft > 1);
      el.toggleAttribute('data-r', el.scrollLeft + el.clientWidth < el.scrollWidth - 1);
    };
    mark();
    el.addEventListener('scroll', mark, { passive: true });
    const ro = new ResizeObserver(mark);
    ro.observe(el);
    for (const c of el.children) ro.observe(c);
    return () => { el.removeEventListener('scroll', mark); ro.disconnect(); };
  }, []);
  return <div ref={ref} className={`sstrip ${className}`} {...rest}>{children}</div>;
}
